import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {WorkrequestpfiComponent} from '../workrequest-pfi/workrequest-pfi.component';
import {LoginService} from '../../../shared/services/login.service';
import {Router} from '@angular/router';
import {UploadFileComponent} from '../../../shared/components/upload-file/upload-file.component';
import {UploadfilesViewmodel} from '../../../shared/viewmodels/uploadfiles-viewmodel';
import {Steps} from 'primeng/primeng';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ServiceBase} from '../../../shared/services/service-base';
import {PfiService} from '../pfi.service';
import {Pfi} from '../pfi';
import {WorkrequestPfiViewmodel} from '../workrequest-pfi-viewmodel';
import {WorkrequestPfiDetails} from '../workrequest-pfi-details';
import {Meta} from '@angular/platform-browser';

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-pfi',
  templateUrl: 'pfi.component.html',
  styleUrls: ['pfi.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, WorkrequestpfiComponent,
    UploadFileComponent, IppaymentComponent],
  encapsulation: ViewEncapsulation.None
})

export class PfiComponent extends ApplicationFormBase<Pfi> implements OnInit {
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/pfi.png';

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestpfiComponent;
  @ViewChild("address") address: AddressDetailsComponent;

  constructor(protected loginService: LoginService,
              private pfiService: PfiService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(pfiService, loginService, ipPaymentService, router);
    this.meta.updateTag({ name: 'description', content: 'Request pressure and flow information from our water main(s).' });
  }

  async ngOnInit() {    
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.initPfiAndBoe(this.workrequestComponent.totalOrderAmount);
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.initPfiAndBoe(this.workrequestComponent.totalOrderAmount);
    }
  }

  onFeeCodesReceived(): void {
  }

  get controlLabel(): string {
    return 'Upload file';
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get commitDisabled(): boolean {
    return (
      !this.pfiService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
      this.workrequestComponent.invalid);
  }

  get workRequestViewModel(): WorkrequestPfiViewmodel {
    return <WorkrequestPfiViewmodel>this.pfiService.workRequestViewModel;
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.pfiService.uploadfilesViewmodel;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.pfiService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      this.navigateFromLocationForPFI(executeYes, executeNo);
    } else if (this.activeIndex === 1) {
      this.workrequestComponent.errorMessage = null;
      if (!this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
        this.workrequestComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) {
      if (!this.uploadFileComponent.isValid) {
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.pfiService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }
      this.validTermsAndConditions(executeNo, executeYes);
    // } else if (this.isGuestUserLoggedIn && this.activeIndex === 4) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 4) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this))
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this))
    // } else if (this.isGuestUserLoggedIn && this.activeIndex === 5) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 5) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 4) || (this.isGuestUserLoggedIn && this.activeIndex === 5)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 4) || (!this.loginService.isUserBillLater() && this.activeIndex === 5)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === 5 || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 5 || this.activeIndex === 0)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get pfi(): Pfi {
    return this.pfiService.applicationData as Pfi;
  }

  submitApplication(callback): void {

    let validData = true;
    this.pfiService.submitErrorMessage = '';

    this.workrequestComponent.errorMessage = null;
    if (!this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
      this.pfiService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      validData = false;
    }

    if (!this.uploadFileComponent.isValid) {
      this.pfiService.submitErrorMessage += this.uploadFileComponent.submitErrorMessage;
      validData = false;
    }

    if (this.applicant.invalid) {
      this.pfiService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.pfiService.agreedToTsAndCs) {
      this.pfiService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }
    this.setApplicantData();
    this.pfiService.applicationData.toUpperCase();
    this.pfiService.applicationData.workrequestDetails =
      <WorkrequestPfiDetails>this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.pfiService.applicationData.workrequestDetails.setDescriptionOfWork();
    this.pfiService.applicationData.locationAddress = this.location.addressDetails.locationAddress || '1 MCNAB AVENUE, FOOTSCRAY';
    this.setWorkRequestData();
    this.doSubmit(callback);
  }

  setWorkRequestData() {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).planOfSubdivisionNumber = this.location.addressDetails.plan;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).lotNumber = this.location.addressDetails.lot;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).streetName = this.location.addressDetails.street;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).unitNumber = this.location.addressDetails.unitNumber;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).streetNumber = this.location.addressDetails.streetNumber;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).streetType = this.location.addressDetails.streetTypeId;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).streetSuffixType = this.location.addressDetails.streetSuffixTypeId > -1 ? this.location.addressDetails.streetSuffixTypeId : null;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).suburb = this.location.addressDetails.suburb;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).postCode = this.location.addressDetails.postCode;
    this.pfiService.applicationData.workrequestDetails = <WorkrequestPfiDetails>this.workrequestComponent.workRequestViewModel.workrequestDetails;
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.uploadFileComponent.clearFiles();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.workrequestComponent.resetSupplyPoints();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && this.activeIndex === 5;
    return !this.loginService.isUserBillLater() && this.activeIndex === 5;
  }

  get shouldDisplayNextButton(): boolean {
    // return (!this.isGuestUserLoggedIn && this.activeIndex !== 4) || (this.isGuestUserLoggedIn && (this.activeIndex !== 4 && this.activeIndex !== 5))
    return (this.loginService.isUserBillLater() && this.activeIndex !== 4) || 
           (!this.loginService.isUserBillLater() && (this.activeIndex !== 4 && this.activeIndex !== 5))
  }

  get shouldShowSubmitAndReview(): boolean {
    return this.activeIndex === 4;
  }

  private doSubmit(callback): void {
    this.executeSubmit('pfi', callback, this.workrequestComponent.totalOrderAmount, this.uploadFileComponent, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/pfi-form/pfi/pfi.component.ts